module.exports = __webpack_public_path__ + "img/hotelFamily-7.4a24372d.jpg";